// extracted by mini-css-extract-plugin
module.exports = {"conteudo-customizado":"ModalExcluir_conteudo-customizado__c1ZIt"};